import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import {
  Response,
  TQueryParams,
  formatQueryParams,
  parseJsonApiResponse,
  prepareHeaders,
} from 'evolve-ui';

export type TCountry = {
  id: string;
  name: string;
};

export const countriesApi = createApi({
  reducerPath: 'countries',
  baseQuery: fetchBaseQuery({
    // TODO: change to countries api url
    baseUrl: `${process.env.GATSBY_OFFERS_API_URL}/countries`,
    mode: 'cors',
    prepareHeaders,
  }),
  tagTypes: ['Country'],
  endpoints: (builder) => ({
    getCountries: builder.query<Response<TCountry>, TQueryParams>({
      providesTags: ['Country'],
      query: formatQueryParams,
      transformResponse: parseJsonApiResponse<TCountry>,
    }),
  }),
});

export const { useGetCountriesQuery } = countriesApi;
